import { render, staticRenderFns } from "./hqglLogisticsItemSale.vue?vue&type=template&id=3b8c09ef&scoped=true&"
import script from "./hqglLogisticsItemSale.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsItemSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c09ef",
  null
  
)

export default component.exports